import { render, staticRenderFns } from "./ProjectTagsField.vue?vue&type=template&id=42ebf84a&"
import script from "./ProjectTagsField.vue?vue&type=script&lang=ts&"
export * from "./ProjectTagsField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports